import React, { useState } from 'react';
import { Row, Col, Dropdown, Pagination, Stack } from 'react-bootstrap';

export interface ExternalPaginationData {
	currentPage: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	pageSize: number;
	totalCount: number;
	totalPages: number;
}

export interface ExternalPaginationProps extends ExternalPaginationData {
	onPageChange: (page: number) => void;
	onSizePerPageChange: (size: number) => void;
}

function ExternalPagination(props: ExternalPaginationProps) {
	const {
		hasNextPage,
		hasPreviousPage,
		currentPage,
		pageSize,
		totalCount,
		totalPages,
		onPageChange,
		onSizePerPageChange,
	} = props;
	const PAGE_SIZES = [10, 25, 30, 50];

	const PAGES_OFFSET = 4;
	let fromPage = currentPage - Math.floor(PAGES_OFFSET / 2);
	fromPage = fromPage < 1 ? 1 : fromPage;
	let toPage = fromPage + PAGES_OFFSET;
	toPage = toPage > totalPages ? totalPages : toPage;
	const pages: number[] = [];
	for (let i = fromPage; i <= toPage; i++) {
		pages.push(i);
	}
	return (
		<Stack direction='horizontal' gap={3}>
			<Dropdown>
				<Dropdown.Toggle variant='secondary' id='pagination-ext'>
					{pageSize}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{PAGE_SIZES.map((size) => (
						<Dropdown.Item key={size} onClick={() => onSizePerPageChange(size)}>
							{size}
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
			<div>{totalCount} risultati</div>
			{totalPages > 1 && (
				<div className='ms-auto'>
					<Pagination>
						{hasPreviousPage && (
							<Pagination.Item onClick={() => onPageChange(currentPage - 1)}>Prec.</Pagination.Item>
						)}
						{pages.map((i) => {
							return (
								<Pagination.Item key={i} active={i === currentPage} onClick={() => onPageChange(i)}>
									{i}
								</Pagination.Item>
							);
						})}
						{hasNextPage && (
							<Pagination.Item onClick={() => onPageChange(currentPage + 1)}>Succ.</Pagination.Item>
						)}
					</Pagination>
				</div>
			)}
		</Stack>
	);
}

export default ExternalPagination;
